export default ".state-button{width:100%;height:100%;padding:0;border:none;background:none}";